import { styled } from 'styled-components';
import { getFontSize, colors } from '../../abstracts';
export const Anchor = styled.a.withConfig({
  componentId: "aui__sc-w7wvnr-0"
})(["display:inline-flex;align-items:center;color:", ";font-size:", ";text-decoration:underline;cursor:pointer;&:visited:not(.disabled):not([aria-disabled='true']){color:", ";}&:active:not(.disabled):not([aria-disabled='true']){color:", ";}&.disabled,&[aria-disabled='true']{color:", ";cursor:not-allowed;&:active,&:focus,&:focus-within,&:focus-visible{pointer-events:none;}}"], ({
  theme,
  $color
}) => theme[$color], getFontSize(2), ({
  theme,
  $color
}) => theme[`${$color}Pressed`], ({
  theme,
  $color
}) => theme[`${$color}Pressed`], colors.disabledText);
export const IconWrapper = styled.div.withConfig({
  componentId: "aui__sc-w7wvnr-1"
})(["display:flex;align-items:center;", ";"], ({
  $iconSide
}) => $iconSide === 'left' ? 'margin-right: 2px' : 'margin-left: 2px');